import { BiRectangle, BiSolidCommentDetail } from 'react-icons/bi';
import { BsCloudRain, BsGlobe2 } from 'react-icons/bs';
import { FaClipboardList } from 'react-icons/fa';
import { GrInstall } from 'react-icons/gr';
import { HiSpeakerphone } from 'react-icons/hi';
import { IoMdSchool } from 'react-icons/io';
import { IoPricetag, IoShieldCheckmarkSharp, IoCube } from 'react-icons/io5';
import {
  MdDone,
  MdOutlineAddLocationAlt,
  MdOutlineLocationOff,
  MdOutlinePinDrop,
  MdOutlineShareLocation,
  MdOutlineWrongLocation,
  MdRocketLaunch,
  MdSearch,
  MdSpeed,
  MdHome,
  MdHandyman,
} from 'react-icons/md';
import { PiCirclesFourFill, PiGpsFixFill } from 'react-icons/pi';
import {
  RiMapPin2Fill,
  RiMoneyDollarCircleFill,
  RiShieldFlashLine,
} from 'react-icons/ri';

interface IconComponentProps {
  name: string;
  className?: string;
  fill?: string;
}

const IconComponent = ({
  name,
  className = 'size-9',
  fill,
}: IconComponentProps) => {
  const fillColor = fill || '#FFFFFF';
  const icons: Record<string, JSX.Element> = {
    MdRocketLaunch: <MdRocketLaunch className={className} fill={fillColor} />,
    MdHome: <MdHome className={className} fill={fillColor} />,
    MdHandyman: <MdHandyman className={className} fill={fillColor} />,
    RiMapPin2Fill: <RiMapPin2Fill className={className} fill={fillColor} />,
    IoPricetag: <IoPricetag className={className} fill={fillColor} />,
    HiSpeakerphone: <HiSpeakerphone className={className} fill={fillColor} />,
    RiMoneyDollarCircleFill: (
      <RiMoneyDollarCircleFill className={className} fill={fillColor} />
    ),
    GrInstall: <GrInstall className={className} fill={fillColor} />,
    IoMdSchool: <IoMdSchool className={className} fill={fillColor} />,
    IoShieldCheckmarkSharp: (
      <IoShieldCheckmarkSharp className={className} fill={fillColor} />
    ),
    IoCube: <IoCube className={className} fill={fillColor} />,
    PiCirclesFourFill: (
      <PiCirclesFourFill className={className} fill={fillColor} />
    ),
    RiShieldFlashLine: (
      <RiShieldFlashLine className={className} fill={fillColor} />
    ),
    BiSolidCommentDetail: (
      <BiSolidCommentDetail className={className} fill={fillColor} />
    ),
    MdSpeed: <MdSpeed className={className} fill={fillColor} />,
    BiRectangle: <BiRectangle className={className} fill={fillColor} />,
    BsCloudRain: <BsCloudRain className={className} fill={fillColor} />,
    FaClipboardList: <FaClipboardList className={className} fill={fillColor} />,
    BsGlobe2: <BsGlobe2 className={className} fill={fillColor} />,
    MdOutlineLocationOff: <MdOutlineLocationOff className={className} />,
    MdOutlinePinDrop: <MdOutlinePinDrop className={className} />,
    MdOutlineShareLocation: <MdOutlineShareLocation className={className} />,
    MdOutlineWrongLocation: <MdOutlineWrongLocation className={className} />,
    MdOutlineAddLocationAlt: <MdOutlineAddLocationAlt className={className} />,
    MdSearch: <MdSearch className={className} />,
    MdDone: <MdDone className={className} />,
    PiGpsFixFill: <PiGpsFixFill className={className} />,
  };

  return icons[name] || null;
};

export default IconComponent;
